import { useQuery, useInfiniteQuery, useQueryClient } from 'react-query'
import { useRouter } from 'next/router'
import { getReviewsService } from 'services/reviews'

const TEN_MINUTES = 1000 * 60 * 10

export async function prefetchReviews({ queryClient, course }) {
  const courseKey = course || null
  await queryClient.prefetchInfiniteQuery(
    ['REVIEWS', courseKey],
    ({ pageParam = 1 }) => getReviewsService({ page: pageParam, course }),
  )
  queryClient.setQueryData(['REVIEWS', courseKey], (data) => ({
    pages: data.pages,
    pageParams: [1],
  }))
}

export async function prefetchInfiniteReviews({ queryClient }) {
  const page_size = 84
  await queryClient.prefetchInfiniteQuery(
    ['GET_INFINITE_REVIEWS', page_size],
    ({ pageParam = 1 }) => getReviewsService({ page: pageParam, page_size }),
  )
  queryClient.setQueryData(['GET_INFINITE_REVIEWS', page_size], (data) => ({
    pages: data.pages,
    pageParams: [1],
  }))
}

export function useInfiniteReviews() {
  const queryClient = useQueryClient()
  const { query: { page_size } } = useRouter()
  const elements = page_size || 84
  return useInfiniteQuery(
    ['GET_INFINITE_REVIEWS', elements],
    ({ pageParam = 1 }) => getReviewsService({ page: pageParam, page_size: elements }),
    {
      getNextPageParam: ({ next }) =>{
        const nextParam = next?.slice(next?.indexOf('page=') + 5)
        return nextParam
      },
      getPreviousPageParam: ({ previous }) =>{
        const previousParam = previous?.slice(previous?.indexOf('page=') + 5)
        return previousParam
      },
      initialData: () => {
        const queryCacheData = queryClient.getQueryData(['REVIEWS', null])
        if (queryCacheData) {
          return {
            pageParams: [undefined, '2'],
            pages: [queryCacheData],
          }
        }
      },
      staleTime: TEN_MINUTES,
      cacheTime: TEN_MINUTES,
    },
  )
}

export function useInfiniteCourseReviews() {
  const router = useRouter()
  const queryClient = useQueryClient()
  const { query: { course } } = router
  return useInfiniteQuery(
    ['REVIEWS', course],
    ({ pageParam = 1 }) => getReviewsService({ course, page: pageParam }),
    {
      getNextPageParam: ({ next }) =>{
        const nextParam = next?.slice(next?.indexOf('page=') + 5)
        return nextParam
      },
      getPreviousPageParam: ({ previous }) =>{
        const previousParam = previous?.slice(previous?.indexOf('page=') + 5)
        return previousParam
      },
      initialData: () => {
        const queryCacheData = queryClient.getQueryData(['REVIEWS', course])
        if (queryCacheData) {
          return {
            pageParams: [undefined, '2'],
            pages: [queryCacheData],
          }
        }
      },
      staleTime: TEN_MINUTES,
      cacheTime: TEN_MINUTES,
    },
  )
}
